import { Icon } from "@smartsuite/react-ui/lib";
import * as S from "./styles";
import { GrayColors } from "@smartsuite/types";

export const CloseButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <S.Root onClick={onClick} role="button">
      <Icon
        dimension={{ width: 24, height: 24 }}
        color={GrayColors["G-3"]}
        name={"close"}
      />
    </S.Root>
  );
};
